<div class="loading-overlay" *ngIf="isLoading">
  <div class="loader-container">
    <div class="loader-spinner"></div>
    <p class="loader-text">Chargement en cours...</p>
  </div>
</div>

<div class="logs-page-container">
  <div class="logs-content-wrapper">
      <!-- Tableau logs -->
      <div class="logs-table-container">
        <!-- Header avec filtre de recherche et filtre catégorie -->
        <div class="px-6 py-4 border-b border-gray-200 flex items-center gap-4 relative">
          <!-- Filtre de recherche centré avec nombre de résultats à droite -->
          <div class="search-container-fixed flex-1 flex items-center justify-center gap-3">
            <div class="relative w-full max-w-xs">
              <span class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 material-symbols-outlined text-sm pointer-events-none">search</span>
              <input
                type="text"
                class="search-input-logs w-full pl-9 pr-3 py-1.5 text-sm border border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
                [(ngModel)]="searchTerm"
                (input)="applyFilter()"
                placeholder="Rechercher dans les logs..."
              />
            </div>
            <span class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-gray-100 text-gray-700 whitespace-nowrap">
              {{ filteredLogs.length }} résultat{{ filteredLogs.length > 1 ? 's' : '' }}
            </span>
          </div>
          
          <!-- Filtre catégorie à droite -->
          <div class="flex-shrink-0">
            <select 
              (change)="chooseCategorie($event)" 
              class="logs-category-select px-4 py-2 border border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none text-sm bg-white cursor-pointer">
              <option value="">Toutes les catégories</option>
              <option *ngFor="let c of categories" [value]="c">{{ c }}</option>
            </select>
          </div>
        </div>

        <div class="overflow-x-auto">
          <table class="logs-table">
            <thead class="logs-table-header">
              <tr>
                <th class="cursor-pointer hover:bg-gray-50 transition-colors min-w-[180px] text-center" (click)="toggleSort('date')">
                  <div class="flex items-center justify-center gap-2">
                    <span>Date</span>
                    <span class="sort-icon text-xs" [ngClass]="sortField === 'date' ? (sortDirection === 'asc' ? 'asc' : 'desc') : ''">
                      <span *ngIf="sortField !== 'date'">↕</span>
                      <span *ngIf="sortField === 'date' && sortDirection === 'asc'">↓</span>
                      <span *ngIf="sortField === 'date' && sortDirection === 'desc'">↑</span>
                    </span>
                  </div>
                </th>
                <th class="cursor-pointer hover:bg-gray-50 transition-colors min-w-[150px] text-center" (click)="toggleSort('categorie')">
                  <div class="flex items-center justify-center gap-2">
                    <span>Catégorie</span>
                    <span class="sort-icon text-xs" [ngClass]="sortField === 'categorie' ? (sortDirection === 'asc' ? 'asc' : 'desc') : ''">
                      <span *ngIf="sortField !== 'categorie'">↕</span>
                      <span *ngIf="sortField === 'categorie' && sortDirection === 'asc'">↓</span>
                      <span *ngIf="sortField === 'categorie' && sortDirection === 'desc'">↑</span>
                    </span>
                  </div>
                </th>
                <th class="min-w-[300px] text-center">Détail</th>
              </tr>
            </thead>
            <tbody class="bg-white">
              <tr *ngFor="let l of filteredLogs" class="logs-table-row">
                <!-- DATE -->
                <td class="logs-table-cell text-center">
                  {{ l.date | date: 'dd/MM/yyyy HH:mm:ss' }}
                </td>

                <!-- CATÉGORIE -->
                <td class="logs-table-cell text-center">
                  <span class="badge-categorie bg-blue-50 text-blue-700 border-blue-200">
                    {{ l.categorie }}
                  </span>
                </td>

                <!-- TEXTE FORMATÉ -->
                <td class="logs-table-cell text-start whitespace-normal">
                  <ng-container *ngIf="l.texte.includes('a modifié le crédit de')">
                    <div class="text-gray-500 mb-1 text-sm">
                      {{ l.texte.split('a modifié le crédit de')[0].trim() }}
                    </div>
                    <div class="font-medium text-gray-700 mb-1">a modifié le crédit de :</div>
                    <div class="text-blue-600 font-semibold">
                      {{ l.texte.split('a modifié le crédit de')[1]?.split(':')[0]?.trim() }}
                    </div>
                    <div class="text-green-600 font-semibold">
                      {{ l.texte.split(':')[1]?.trim() }}
                    </div>
                  </ng-container>

                  <ng-container *ngIf="!l.texte.includes('a modifié le crédit de')">
                    <span class="text-gray-800">{{ l.texte }}</span>
                  </ng-container>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Pagination -->
      <div class="mt-6 flex justify-center">
        <app-pagination
          [currentPage]="currentPage"
          [totalPages]="totalPages"
          (pageChange)="getLogs($event)">
        </app-pagination>
      </div>
    </div>
</div>
